<template>
  <AppHeader />
  <div class="AppDocumentsFiltered_container">
    <div class="AppDocumentsFiltered_left">
      <AppNavigation />
    </div>
    <div class="AppDocumentsFiltered_right">
      <div class="AppDocumentsFiltered_content">
        <div class="AppDocumentsFiltered_header">
          <div class="AppDocumentsFiltered_button">
            <AppButton size="medium" type="outline" primaryColor="#4198f0" iconType="arrow-left" style="border-color: #c3c8cc; gap: 0; padding: 0.75rem" @click="$router.go(-1)" />
          </div>
          <div class="AppDocumentsFiltered_title">{{ $t('views.AppDocumentsFiltered.title.' + $route.params.filter) }}</div>
        </div>
        <DocumentList :documents="documents" :omit="['actions']" />
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import AppNavigation from "@/components/AppNavigation";
import DocumentList from "@/components/DocumentList";
import { checkErrors } from "@/utilities/errors";
import DocumentsService from "@/services/documents";
import events from "@/events";
import AppButton from "@/components/AppButton";

export default {
  name: "AppDocumentsFiltered",
  components: {
    DocumentList,
    AppNavigation,
    AppHeader,
    AppButton
  },
  setup() {
    return {
      events
    };
  },
  mounted() {
    this.getDocuments();
  },
  data() {
    return {
      documents: null,
      gettingDocuments: false,
      root: null
    }
  },
  methods: {
    getDocuments() {
      if (this.gettingDocuments) {
        return;
      }

      this.gettingDocuments = true;

      const Documents = new DocumentsService(process.env.VUE_APP_API_URL, process.env.VUE_APP_API_ID);

      Documents.searchFiltered(this.$route.params.filter)
          .then((data) => {
            this.root = data?.root;
            this.documents = data?.documents;
            this.documents.sort((a, b) => {
              if (a.type === "folder" && b.type !== "folder") {
                return -1;
              }

              if (a.type !== "folder" && b.type === "folder") {
                return 1;
              }

              return 0;
            });

            this.gettingDocuments = false;
          })
          .catch((error) => {
            this.gettingDocuments = false;

            checkErrors(error);
          });
    }
  }
}
</script>

<style lang="scss" scoped>
.AppDocumentsFiltered_container {
  display: flex;
  flex-direction: row;
  flex: 1;

  .AppDocumentsFiltered_left {
    display: flex;
    flex-direction: column;
  }

  .AppDocumentsFiltered_right {
    flex: 1;
    display: flex;
    flex-direction: row;

    .AppDocumentsFiltered_content {
      flex: 1;
      padding: 1.5rem;
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .AppDocumentsFiltered_header {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 1.5rem;

        .AppDocumentsFiltered_title {
          font-weight: 700;
          font-size: 1.5rem;
          line-height: 2.0rem;
          color: #163b61;
          padding-top: 0.25rem;
        }
      }
    }
  }
}
</style>
